import AggregableColumnManager from '../aggregable/AggregableColumnManager';

export default class GeneralColumnManager extends AggregableColumnManager {
}